import React from 'react'
import "./AboutPageElementCss/ExpertProfileModal.css";
import logo from "../../Assets/logo.png";
const MemberDetailsModal = ({ isOpen, onClose, expert }) => {
    if (!isOpen || !expert) return null;

  return (
    
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

        <div className="expert-modal-header-row">
          <div className="expert-modal-image">
            <img
              src={expert.image}
              alt={expert.name}
            />
          </div>

          <div className="expert-modal-info">
            <img src={logo} alt="RB Diagnostics Logo" className="rb-logo" />
            <h2 className="expert-name">{expert.name}</h2>
            <p className="expert-role">{expert.role}</p>
          </div>
        </div>

        {/* ✅ DESCRIPTION FIXED */}
        {expert.description && (
          <div className="expert-modal-description">
            {expert.description}
          </div>
        )}

        <button onClick={onClose} className="close-btn">Close</button>
      </div>
    </div>
  );
  
}

export default MemberDetailsModal